import { render } from "./CanvassingOrgCampaignTable.vue?vue&type=template&id=e5941ab8&scoped=true"
import script from "./CanvassingOrgCampaignTable.vue?vue&type=script&lang=js"
export * from "./CanvassingOrgCampaignTable.vue?vue&type=script&lang=js"

import "./CanvassingOrgCampaignTable.vue?vue&type=style&index=0&id=e5941ab8&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/nce_go/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5941ab8"]])

export default __exports__